import React from 'react';
import { List, Set } from 'immutable';
import ElementBuilder from './elements/ElementBuilder.jsx';
import { selectDealsPage, scrolledToTop } from '@/store/allaround.store';
import { connect } from 'react-redux';
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import 'rc-select/assets/index.css';
import Select from 'rc-select';
import locale from './pagination_en_US';
import { validateRoleConfig,
  userHasDealRegion, isUserDeal } from '../../auth/RoleConfigFilter.jsx';

import DealListEvents from './elements/DealListEvents.jsx';
import { loadAddDicts, areAllTheDictsLoaded } from '@/component/dict/DictLoader.js';
import { loadAllDeals, areAllTheDealsLoaded } from './DealLoader.js';
import { clearDealEditType } from './store/deal.store';
import { clearWsData } from './store/deals.store';
import { resetFilters } from './store/search.store.js';
import { calculateUnlinkedObject } from './elements/BaseElement.jsx';
import { dirtyIEHack, locationFallThroughInitial } from '@/util/util.jsx';
import { saveScrollPosition } from '@/store/scroll.store';

export const compareDate = (dateA, dateB) => {
  if (!dateA && !dateB) {
    return 0;
  }
  if (!dateA) {
    return -1;
  }
  if (!dateB) {
    return 1;
  }
  return new Date(dateA) > new Date(dateB) ? -1 : 1;
};
export const shipmentToProductsComparator = (productA, productB) => {
  let productADate = undefined;
  let productBDate = undefined;
  if (productA) {
    productADate = productA.get('shipmentTo');
  }
  if (productB) {
    productBDate = productB.get('shipmentTo');
  }
  return compareDate(productADate, productBDate);
};
export const getShipmentToDateFromDeal = (deal) => {
  if (deal && deal.get('products')) {
    const maxShipmentToProduct = deal.get('products').min(shipmentToProductsComparator);
    if (maxShipmentToProduct) {
      return maxShipmentToProduct.get('shipmentTo');
    }
  }
  return undefined;
};

export const shipmentToDealsComparator = (dealA, dealB) => {
  const dealAShipmentToDate = getShipmentToDateFromDeal(dealA);
  const dealBShipmentToDate = getShipmentToDateFromDeal(dealB);
  return compareDate(dealAShipmentToDate, dealBShipmentToDate);
};

class Deals extends React.Component {
  constructor(props) {
    super(props);
    this.onPageChange = this.onPageChange.bind(this);
    this.onShowSizeChange = this.onShowSizeChange.bind(this);
    this.filterData = this.filterData.bind(this);
    this.selectPage = this.selectPage.bind(this);
    this.initScrollPosition = this.initScrollPosition.bind(this);
    this.state = {
      originalData: undefined,
      data: undefined,
      filter: undefined,
      pageSize: 100,
      current: 1,
      total: 0,
      urlParamsInit: false,
    };
    this.dontScroll = false;
    this.initScroll = true;
    this.didLoad = false;
  }

  componentWillMount() {
    this.didLoad = false;
    this.props.clearDealEditType();
    locationFallThroughInitial(`${this.props.type}s`, `/deals/${this.props.type}`);
    loadAddDicts();
    loadAllDeals();
    if (!areAllTheDictsLoaded() || !areAllTheDealsLoaded()) {
      return;
    }
    if (this.props.filter) {
      this.setState({ filter: this.props.filter });
    }
    this.initScrollPosition();
    this.didLoad = true;
    this.filterData(this.props);
  }


  componentDidMount() {
    dirtyIEHack();
  }

  componentWillReceiveProps(props, context) {
    if (!areAllTheDictsLoaded() || !areAllTheDealsLoaded()) {
      return;
    }
    this.initScrollPosition(props, context);
    this.didLoad = true;
    if (props.scrollToTop) {
      props.selectPage(1, context.location.query.pageSize ?
        parseInt(context.location.query.pageSize, 10) : 100);
      props.scrolledToTop();
    }
    if (this.props.current == props.current && this.props.pageSize == props.pageSize) {
      this.dontScroll = true;
    } else {
      this.dontScroll = false;
    }
    if (!props.scrollToTop && props.filter != this.props.filter) {
      this.selectPage(this.props.current, this.props.pageSize);
    }

    if (props.filter) {
      this.setState({ filter: props.filter });
    }
    this.filterData(props);
  }

  shouldComponentUpdate(nextProps) {
    if ((nextProps.data || (nextProps.type == 'unlinked' && nextProps.purchases && nextProps.sales))
      && areAllTheDictsLoaded() && areAllTheDealsLoaded()) {
      return true;
    } return false;
  }

  componentDidUpdate() {
    dirtyIEHack();
    if (!this.dontScroll || this.props.scrollToTop || this.initScroll) {
      const scrollPosition = this.props.scrollPositions
        .get(`${this.props.type}${this.props.current}`) || 0;
      window.scrollTo(0, scrollPosition);
      if (this.initScroll && document.body.clientHeight >= scrollPosition) {
        this.initScroll = false;
      }
    }
  }
  componentWillUnmount() {
    this.props.saveScrollPosition(`${this.props.type}${this.props.current}`);
  }

  onPageChange(current) {
    this.props.saveScrollPosition(`${this.props.type}${this.props.current}`);
    this.selectPage(current, this.props.pageSize);
  }
  onShowSizeChange(current, pageSize) {
    this.selectPage(1, pageSize);
  }

  getDataToDisplay(data, type, newPage, pageSize, mode) {
    const newMode = !mode ? '' : mode;
    return data
      .slice(newPage * pageSize - pageSize,
        newPage * pageSize)
      .map((elem, idx) => (
        <ElementBuilder
          key={elem.get('id') ? `${elem.get('id')}${elem.get('dealType', '')}` : idx}
          data={elem}
          type={`${newMode}${type == 'unlinked' ? elem.get('dealType') : type}`}
          dealIdx={idx}
        />
      )).toArray();
  }

  filterResetChooser = (deal) => {
    const transportType = deal.get('transportType');
    if (transportType) {
      if (this.props.tTypes.has(transportType)) {
        this.props.resetFilters('myDeals', 'ttypes');
      } else {
        this.props.resetFilters('myDeals');
      }
    } else {
      this.props.resetFilters('myDeals');
    }
  };

  initScrollPosition(props = this.props, context = this.context) {
    if (this.didLoad) {
      return;
    }
    if (!this.state.urlParamsInit && context.location.query &&
      context.location.query.pageSize && context.location.query.pageNumber) {
      if (props.scrollToTop) {
        props.selectPage(1,
          parseInt(context.location.query.pageSize, 10));
        props.scrolledToTop();
      } else {
        props.selectPage(parseInt(context.location.query.pageNumber, 10),
          parseInt(context.location.query.pageSize, 10));
      }
      this.setState({ urlParamsInit: true });
    } else {
      this.selectPage(props.current, props.pageSize);
    }
  }
  selectPage(current, pageSize) {
    if (this.props.mode == 'connect') {
      this.setState({ current, pageSize });
      this.filterData(Object.assign({}, this.props, { current, pageSize }));
    } else {
      this.props.selectPage(current, pageSize);
    }
  }

  tryToFindValueInObject(valueToFind, objectToCheck, propertyName) {
    if (!objectToCheck.get(propertyName)) {
      return false;
    }
    let objectsValue = objectToCheck.get(propertyName);
    if (propertyName === 'packing' && this.props.packingList) {
      const thisPacking = this.props.packingList
        .find(pack => pack.get('id') === objectToCheck.get(propertyName));
      objectsValue = thisPacking ? thisPacking.get('name') : '';
    }
    if (Array.isArray(valueToFind)) {
      if (typeof objectsValue === 'string'
        || objectsValue instanceof String) {
        const arrayToLowerCaseString = valueToFind.toString().toLowerCase();
        if (arrayToLowerCaseString.indexOf(objectsValue.toLowerCase()) > -1) {
          return true;
        }
      }
      if (valueToFind.indexOf(objectsValue) > -1) {
        return true;
      }
    }

    if ((typeof objectsValue === 'string'
      || objectsValue instanceof String) &&
      objectsValue.toLowerCase().indexOf(valueToFind.toLowerCase()) > -1) {
      return true;
    }

    if (objectsValue == valueToFind) {
      return true;
    }
    return false;
  }

  filterUnlinkedProductFunc(product, dealType) {
    if (product.get('completedLink')) {
      return false;
    }
    const unlinked = calculateUnlinkedObject(product);
    let show = false;
    if ((unlinked.quantityMin || 0) >= 1) {
      show = true;
    }

    const links = product.get(`${dealType}Link`, new List());
    const otherDealType = dealType == 'purchase' ? 'sale' : 'purchase';
    links.forEach(link => {
      if (!show && !link.get(`${otherDealType}Product`)
        && link.get(`${otherDealType}Product`) !== 0) {
        show = true;
      }
    });
    return show;
  }

  filterUnlinkedTransport(transport) {
    return !transport.get('links', new List()).some(
      l => (l.get('purchaseId') || l.get('purchaseId') === 0)
        && (l.get('saleId') || l.get('saleId') === 0));
  }

  applyFilters(usedFilters, dataToFilter = new List()) {
    let result = dataToFilter;
    if (usedFilters) {
      usedFilters.forEach((valueToFind, propName) => {
        if (valueToFind && propName === 'productType' && Array.isArray(valueToFind)
          && valueToFind.length === 0) {
          result = new List();
        } else if (valueToFind != undefined && valueToFind != '' && valueToFind != null) {
          result = result.filter((objectToCheck) => {
            if (this.tryToFindValueInObject(valueToFind, objectToCheck, propName)) {
              return true;
            }
            if (objectToCheck.get('products') && objectToCheck.get('products').size > 0) {
              if (propName === 'productType' && objectToCheck.get('products').find(
                prod => valueToFind.indexOf(prod.get('productType')) > -1)) {
                return true;
              }
              let foundInProducts = false;
              objectToCheck.get('products').forEach(product => {
                if (this.tryToFindValueInObject(valueToFind, product, propName)) {
                  foundInProducts = true;
                }
              });
              if (foundInProducts) {
                return true;
              }
            }
            return false;
          });
        }
      });
    }
    return result;
  }

  applyIDFilters(filteredDealIDs, currentUserId, resetFiltersFunc, data = new List()) {
    let result = data;
    if (filteredDealIDs) {
      let filtersWillReset = false;
      result = result.filter(elem => {
        if (filtersWillReset) {
          return true;
        }
        if (elem.get('recieveThroughWebsocket')) {
          if (elem.get('creator') == currentUserId &&
            filteredDealIDs.indexOf(elem.get('id')) == -1) {
            this.filterResetChooser(elem);
            filtersWillReset = true;
            return true;
          }
          this.props.clearWsData(elem.get('id'));
        }
        return filteredDealIDs.indexOf(elem.get('id')) > -1;
      });
    }
    return result;
  }
  removeLinks(dealList = new List()) {
    dealList.map(elem => elem);
  }
  filterData(props) {
    if (!areAllTheDictsLoaded() || !areAllTheDealsLoaded()) {
      return;
    }
    let filteredData = new List();
    if (props.type == 'unlinked') {
      let purchases = props.purchases ? props.purchases : new List();
      purchases = this.applyIDFilters(
        props.filteredPurchaseIDs, props.currentUserId, props.resetFilters, purchases);
      let sales = props.sales ? props.sales : new List();
      sales = this.applyIDFilters(
        props.filteredSaleIDs, props.currentUserId, props.resetFilters, sales);
      purchases = purchases.map(deal => deal.set('dealType', 'purchase'));
      sales = sales
        .map(deal =>
          deal.set('dealType', 'sale')
            .set('pstab', true)
        );
      filteredData = purchases.concat(sales);
      filteredData = filteredData.sort((a, b) => {
        const dateA = new Date(b.get('creationTime', '01 Jan 1970')).getTime();
        const dateB = new Date(a.get('creationTime', '01 Jan 1970')).getTime();
        if (dateA < dateB) { return -1; }
        if (dateA > dateB) { return 1; }
        return 0;
      });
    } else {
      filteredData = props.data ? props.data : new List();
      filteredData = this.applyIDFilters(
        props.filteredDealIDs, props.currentUserId, props.resetWithExclude, filteredData);
    }
    const usedFilters = props.filterBy ? props.filterBy : props.filter;
    filteredData = this.applyFilters(usedFilters, filteredData);
    if (props.type == 'transport') {
      if (!validateRoleConfig(['allTransports#1'])) {
        if (validateRoleConfig(['myTransports#1'])) {
          filteredData = filteredData.filter(deal =>
            isUserDeal(deal) || deal.get('transportType') == 'BULK');
        } else {
          filteredData = new List();
        }
      }
    } else {
      if (validateRoleConfig(['viewDealsByRegion'])) {
        if (!validateRoleConfig(['allDeals#1'])) {
          if (validateRoleConfig(['myDeals#1'])) {
            filteredData = filteredData.filter((deal) =>
              userHasDealRegion(deal) || isUserDeal(deal));
          } else {
            filteredData = filteredData.filter(userHasDealRegion);
          }
        }
      } else if (!validateRoleConfig(['allDeals#1']) && validateRoleConfig(['myDeals#1'])) {
        filteredData = filteredData.filter(isUserDeal);
      }
    }
    const filterUnlinked = props.type == 'unlinked' ?
      props.purchaseFilterUnlinked : props.filterUnlinked;
    if (filterUnlinked) {
      if (props.type == 'transport') {
        filteredData = filteredData.filter(this.filterUnlinkedTransport);
      } else {
        filteredData = filteredData.filter(elem => {
          if (!elem.get('products') || elem.get('products').size == 0) {
            return false;
          }
          const filteredProducts = elem.get('products')
            .filter(product => {
              const result = this.filterUnlinkedProductFunc(product,
                elem.get('dealType') || props.type);
              return result;
            });
          return filteredProducts.size > 0;
        });
      }
    }

    if (props.type == 'unlinked') {
      const shownSaleProducts =
        filteredData.flatMap(elem => elem.get('products', new List()))
          .flatMap(elem => elem.get('purchaseLink', new List()))
          .map(l => l.get('saleProduct'))
          .filter(e => e)
          .toJS();
      filteredData = filteredData.map(elem => {
        if (elem.get('dealType') == 'sale') {
          const notShownProducts = elem.get('products', new List())
            .filter(p => !shownSaleProducts.includes(p.get('id')));
          if (notShownProducts.size) {
            return elem.set('products', notShownProducts);
          }
          return undefined;
        }
        return elem;
      }).filter(e => e);
    }

    const shipmentSort = props.type == 'unlinked' ?
      props.purchaseShipmentSort : props.shipmentSort;
    if (shipmentSort) {
      filteredData = filteredData.sort(shipmentToDealsComparator);
    }

    const pagination = filteredData ? filteredData.size > 25 : false;
    const lastAvailablePage = Math.ceil(filteredData.size / props.pageSize);
    const currentPage = props.current > lastAvailablePage ? lastAvailablePage : props.current;
    this.setState({
      pagination,
      originalData: filteredData,
      data: this.getDataToDisplay(filteredData, props.type,
        currentPage, props.pageSize, props.mode),
      total: filteredData.size,
    });
  }

  render() {
    if (!areAllTheDictsLoaded() || !areAllTheDealsLoaded()) {
      return <div />;
    }
    let renderDeals = false;
    if (this.props.type == 'transport'
      && validateRoleConfig(['allTransports#1', 'myTransports#1'])) {
      renderDeals = true;
    } else if (validateRoleConfig(['allDeals#1', 'myDeals#1', 'viewDealsByRegion'])) {
      renderDeals = true;
    }
    if (renderDeals) {
      return (
        <div className="deals">
          {this.props.mode == 'connect' ? '' : <DealListEvents />}
          {this.state.data ?
            this.state.data
            : <span />}
          {this.state.pagination ?
            <Pagination
              selectComponentClass={Select} showSizeChanger pageSizeOptions={['25', '50', '100']}
              onChange={this.onPageChange} onShowSizeChange={this.onShowSizeChange}
              current={this.props.mode == 'connect' ? this.state.current : this.props.current}
              total={this.state.total} locale={locale} showLessItems className="deal-pagination"
              pageSize={this.props.mode == 'connect' ? this.state.pageSize : this.props.pageSize}
            />
            : ''
          }
        </div>
      );
    }
    return <div />;
  }
}

export default connect(
  (store, props) => ({
    filter: store.getIn(['data', 'deals', 'list', 'filters', props.type]),
    data: store.getIn(['data', 'deals', 'list', props.type]),
    tTypes: store.getIn(['search', props.type, 'filters', 'ttypes'], new Set()),
    purchases: store.getIn(['data', 'deals', 'list', 'purchase']),
    transports: store.getIn(['data', 'deals', 'list', 'transport']),
    sales: store.getIn(['data', 'deals', 'list', 'sale']),
    filteredDealIDs: store.getIn(['search', props.type, 'data']),
    filteredPurchaseIDs: store.getIn(['search', 'purchase', 'data']),
    filteredSaleIDs: store.getIn(['search', 'sale', 'data']),
    filteredDealVersion: store.getIn(['search', props.type, 'dataVersion']),
    pageSize: store.getIn(['allaround', 'dealsPageSize', props.type], 100),
    current: store.getIn(['allaround', 'dealsPage', props.type], 1),
    scrollToTop: store.getIn(['allaround', 'scrollToTop'], false),
    currentUserId: store.getIn(['session', 'id']),
    filterUnlinked: store.getIn(['search', props.type, 'filters', 'unlinked'], false),
    purchaseFilterUnlinked: store.getIn(['search', 'purchase', 'filters', 'unlinked'], false),
    shipmentSort: store.getIn(['sort', props.type, 'shipmentSort'], false),
    purchaseShipmentSort: store.getIn(['sort', 'purchase', 'shipmentSort'], false),
    scrollPositions: store.getIn(['scroll'], new Map()),
    storeStatus: store.getIn(['storeStatus']),
  })
  , (dispatch, props) => ({
    selectPage(pageNumber, pageSize) {
      selectDealsPage(dispatch, pageNumber, pageSize, props.type);
    },
    clearDealEditType() {
      clearDealEditType(dispatch);
    },
    scrolledToTop() {
      scrolledToTop(dispatch);
    },
    resetFilters(...exclude) {
      if (props.type == 'sale' || props.type == 'purchase') {
        resetFilters(dispatch, 'sale', ...exclude);
        resetFilters(dispatch, 'purchase', ...exclude);
      } else {
        resetFilters(dispatch, props.type, ...exclude);
      }
    },
    saveScrollPosition(page = `${props.type}${props.current}`,
      location = window.pageYOffset ? window.pageYOffset : 0) {
      saveScrollPosition(dispatch, page, location);
    },
    clearWsData(id) {
      clearWsData(dispatch, id, props.type);
    },
  }))(Deals);

Deals.propTypes = {
  type: React.PropTypes.string.isRequired,
  tTypes: React.PropTypes.object.isRequired,
  selectPage: React.PropTypes.func.isRequired,
  data: React.PropTypes.object,
  filter: React.PropTypes.object,
  current: React.PropTypes.number,
  pageSize: React.PropTypes.number,
  filterBy: React.PropTypes.object,
  mode: React.PropTypes.string,
  packingList: React.PropTypes.object,
  clearDealEditType: React.PropTypes.func,
  scrollToTop: React.PropTypes.bool,
  scrolledToTop: React.PropTypes.func,
  filteredDealIDs: React.PropTypes.object,
  resetFilters: React.PropTypes.func,
  filteredDealVersion: React.PropTypes.number,
  filterUnlinked: React.PropTypes.bool,
  shipmentSort: React.PropTypes.bool,
  scrollPositions: React.PropTypes.object,
  saveScrollPosition: React.PropTypes.func,
  clearWsData: React.PropTypes.func,
};
Deals.contextTypes = {
  location: React.PropTypes.object,
};
